import { useAppTemplateContext } from '@components/v2/layout/AppTemplate/contexts/AppTemplate.context';
import { Box, useTheme } from '@mui/material';
import useProductDetailsStore from '../../../../../stores/ProductDetails/productDetails.store';
import { selectIsProductDetailsOpen } from '../../../../../stores/ProductDetails/productDetails.store.selectors';
import { ActiveOrderTestIds } from '../../../../../utils/testIds/ActiveOrder.testIds';
import { UsedInOfflineMode } from '../../../../offline/types/UsedInOfflineMode';
import { useRachelDockedWidth } from '../../../../rachel/hooks/useRachelDockedWidth';
import ProductDetailsContent from '../ProductDetailsContent/ProductDetailsContent';
import {
  PRODUCT_DETAILS_PANEL_FRAME_PADDING,
  useProductDetailsPanelStyles,
} from './productDetailsPanel.styles';

const ProductDetailsPanel = ({ isOfflineMode = false }: UsedInOfflineMode) => {
  const isOpen = useProductDetailsStore(selectIsProductDetailsOpen);
  const rachelDockedWidth = useRachelDockedWidth();
  const { sidebarState } = useAppTemplateContext();
  const theme = useTheme();
  const { classes } = useProductDetailsPanelStyles({ sidebarState });

  if (!isOpen) {
    return null;
  }

  const rachelInsetStyle = rachelDockedWidth
    ? {
        right: `calc(${theme.spacing(PRODUCT_DETAILS_PANEL_FRAME_PADDING)} + ${rachelDockedWidth}px)`,
      }
    : undefined;

  return (
    <Box
      className={classes.panel}
      test-id={ActiveOrderTestIds.PRODUCT_DETAILS_MODAL}
      style={rachelInsetStyle}
    >
      <ProductDetailsContent isOfflineMode={isOfflineMode} />
    </Box>
  );
};

export default ProductDetailsPanel;
